<template>
	<main role="main" style="padding-top:0px" class="right_wrapper">
		<div>
			<!-- <div class="page-header">
				<div class="form-row">
					<div class="form-group col-md-10">
						<div class="form-row bread-crumb-small">
								<a href="javascript:void(0)" @click="getBackToCampaignList()" class="form-group" style="line-height:1;margin:0px">Campaign ></a>
							<span class="form-group" style="line-height:1;margin:0px;padding-left:10px">{{campName}}</span>
						</div>
					</div>
				</div>
			</div> -->
			<BreadCrumbHeader
			@backCalled="getBackToCampaignList"
			:selectedName="campName"
			tabCalled='Campaign'
			selectedModule='Campaign'
			/>
			
				<div class = "keyword_nav_container pt-2" style="height:50px">
					<ul class="nav nav-tabs">
						<li v-if="$route.params.type!='exact'">
							<a class="nav-link" @click="setTab('recommended')" :class = "currentPage == 'recommended' ? 'active' : ''">Recommended</a>
						</li>
						<li>
							<a class="nav-link" @click="setTab('exact')" :class = "currentPage == 'exact' ? 'active' : ''">KW Isolation</a>
						</li>
					</ul>
				</div>
				<div class='table_wrap extra_bar'>
				<div v-if="showLoader" class="spinner-border" style="margin:auto;display:block;margin-top:60px"></div>
				<div v-else-if="currentPage=='recommended' && recommendationList.length">
						<table class="table">
							<thead>
								<tr>
									<th style="width:35%">Title</th>
									<th style="width:20%">Match Type</th>
									<th style="width:20%">Bid</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item,index) in recommendationList" :key="item.id" :class="index%2==0?'even':''">
									<td>{{item.rec_key}}</td>
									<td>{{item.rec_match_type}}</td>
									<td>{{item.rec_bid}}</td>
									<td>
										<button @click="addKeyword(item,index)" class="btn btn-primary">Add</button>
										<div v-if="showIgnoreLoader && (ignoredKeywordId == index)" class="spinner-border" ></div>
										<button
											v-else
											type="button"
											style="margin-left:-5px"
											class="btn btn-primary"
											@click = "ignoreRecommendedKeyword(item, index)"
										>Ignore</button>
									</td>
								</tr>
							</tbody>
						</table>
				</div>

				<div v-else-if="currentPage=='exact' && recommendationList.length">
						<table class="table">
							<thead>
								<tr>
									<th style="width:20%">Title</th>
									<th style="width:15%">Match Type</th>
									<th style="width:15%">Cost</th>
									<th>Query</th>
									<th style="width:20%">Search Term Performance</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item,index) in recommendationList" :key="item.id" :class="index%2==0?'even':''">
									<td>{{item.keyword_text}}</td>
									<td>{{item.match_type}}</td>
									<td>{{item.sales}}</td>
									<td>{{item.query}}</td>
									<td><span @click="viewMore(item)"><a href="javascript:void(0)">Search Term Performance</a></span></td>
									<td>
										<button @click="addKeyword(item,index,'exact')" class="btn btn-primary">Add</button>
										<div v-if="showIgnoreLoader && (ignoredKeywordId == index)" class="spinner-border" ></div>
										<button
											v-else-if="currentPage!='exact'"
											type="button"
											style="margin-left:-5px"
											class="btn btn-primary"
											@click = "ignoreRecommendedKeyword(item, index)"
										>Ignore</button>
									</td>
								</tr>
							</tbody>
						</table>
				</div>
				<NoDataAvailable displayMessage="No data available " v-else></NoDataAvailable>
			</div>
			<AddKeywordGroupModal
				v-if = "showAddGroup"
				:ams_campaign_id = "ams_campaign_id"
				:local_campaign_id = "local_campaign_id"
				@hideKeywordGroupModal = "hideKeywordGroupModal"
				:recommended_id = "itemSelectedId"
				:ams_profile_id = "ams_profile_id"
				:campaign_type = "campaign_type"
				:campaignObj = "campaignObj"
				:cost="cost"
				:match_type="match_type"
				:currentPage="currentPage"
				:keyword_text="keyword_text"
				:query_text='query_text'
				:ams_keyword_id='ams_keyword_id'
			/>
			<ExactTypeHistoryPopUp
				ref="exactHistoryDescPopup"
				:showSpinner="fetchingDesc"
				:descArray='history'
			/>
			<RecommendKeywordFooter class="main_footer_wrap" v-if="recommendationList.length && !showLoader" @showPerPageChanged='showPerPageChanged'/>
		</div>
	</main>
</template>
<script>
import ExactTypeHistoryPopUp from './ExactTypeHistoryPopUp.vue';
import AddKeywordGroupModal from './AddKeywordGroupModal.vue';
import RecommendKeywordFooter from './RecommendKeywordFooter';
import NoDataAvailable from '../NoDataAvailable.vue';
import BreadCrumbHeader from "@/components/BreadCrumbHeader.vue";
	export default {
		name: "RecommendKeyword",
		components: {
			AddKeywordGroupModal,
			ExactTypeHistoryPopUp,
			RecommendKeywordFooter,
			NoDataAvailable,
			BreadCrumbHeader
		},
		data() {
			return {
				currentPage:'',
				showLoader: true,
				recommendationList: [],
				index: "",
				campName:'Campaign',
				ams_campaign_id:'',
				local_campaign_id:'',
				showAddGroup:false,
				itemSelectedId:-1,
				showIgnoreLoader:false,
				ignoredKeywordId:-1,
				ams_profile_id:'',
				campaign_type:'',
				campaignObj:{},
				fetchingDesc:false,
				history:[],
				cost:null,
				match_type:null,
				keyword_text:null,
				query_text:'',
				ams_keyword_id:''
			};
		},
		watch:{
			currentPage(){
				if(this.currentPage=='recommended'){
					this.getRecommendKeywords()
				}
				else if(this.currentPage=='exact'){
					this.getExactKeywords()
				}
				
			}
		},
		mounted() {
			this.campName = atob(this.$route.params.campName)
			this.ams_campaign_id = this.$route.params.amsCampId
			this.local_campaign_id = this.$route.params.campId
			this.ams_profile_id = this.$route.params.amsProfileId
			this.campaign_type = this.$route.params.campaignType
			this.currentPage = this.$route.params.type||'recommended'
			// this.getRecommendKeywords();
			this.getCampaignDetails()
		},
		methods: {
			showPerPageChanged(){
				if(this.currentPage=='recommended'){
					this.getRecommendKeywords()
				}
				else if(this.currentPage=='exact'){
					this.getExactKeywords()
				}
			},
			viewMore(item){
				let vm = this;
				vm.$refs["exactHistoryDescPopup"].openPopUp();
				vm.fetchingDesc = true
				vm.history = []
				let payload = {
					"ams_keyword_id":item.ams_keyword_id,
					"tableType":this.campaign_type=='sponsoredBrands'?'sb':'sp',
				}
				this.$store.dispatch("campaign/getexactKeywordHistory", payload).then((resp) => {
					vm.fetchingDesc = false
					vm.history = (resp&&resp.data)?resp.data:[]
				})
			},
			getExactKeywords(){
				let vm = this;
				let payload  = {
					amsCampaignId: this.ams_campaign_id,
					tableType: this.campaign_type=='sponsoredBrands'?'sb':'sp',
				}
				this.showLoader =true
				this.$store.dispatch('campaign/getExactKeywords',payload).then((res) => {
					vm.recommendationList = res?res.data:[]
					vm.showLoader = false
				})
			},
			resetPagination(){
				this.$store.state.recommendedKeywordShowPerPage = 25
				sessionStorage.setItem("keyword:recommendedKeywordShowPerPage", 25);
				this.$store.state.recommendedKeywordCurrentPageNumber = 1
				this.$store.state.recommendedTotalKeywordCount = 0
			},
			setTab(type){
				this.resetPagination()
				this.currentPage = type
			},
			getBackToCampaignList(){
					this.$store.state.calledFromCancel = true;
					this.$router.push({ path: "/campaignList" });

			},
			addKeyword(item, index,type) {
				if(type=='exact'){
					this.cost = item.sales
					this.match_type=item.match_type
					this.keyword_text = item.keyword_text
					this.query_text = item.query
					this.ams_keyword_id = item.ams_keyword_id
				}
				else{
					this.cost = null
					this.match_type=null
					this.keyword_text = null
					this.query_text = ''
					this.ams_keyword_id = ''
				}
				this.itemSelectedId = item.id
				this.showAddGroup = true
			},
			getRecommendKeywords() {
				let vm = this;
				let payload  = {
					ams_campaign_id: this.ams_campaign_id
				}
				this.showLoader = true
				this.$store.dispatch('campaign/getRecommendedKeywords',payload).then((res) => {
					vm.recommendationList = res?res.data:[]
					vm.showLoader = false
				})
				//this.$store.dispatch('campaign/recommendKeyword',payload)
			},
			getCampaignDetails(){
				let payload  = {
					id: this.local_campaign_id
				}
				let vm  =this;
				this.$store.dispatch('campaign/getCampaignById',payload).then((res) => {
					vm.campaignObj = res
				})
			},
			hideKeywordGroupModal(data, isAdded, type){
				this.showAddGroup = false
				if(isAdded){
					let addedIndex = this.recommendationList.findIndex((res) =>  res.id == this.itemSelectedId)
					this.recommendationList.splice(addedIndex, 1)
				}
				this.itemSelectedId = -1
				if(type && type =='Exact'){
					// this.resetPagination()
					if(this.currentPage=='recommended'){
						this.getRecommendKeywords()
					}
					else if(this.currentPage=='exact'){
						this.getExactKeywords()
					}
				}
			},
			ignoreRecommendedKeyword(item, index){
				let payload = {
					ams_campaign_id:this.ams_campaign_id,
					type :"Ignore",
					recommended_id:item.id
				}
				this.ignoredKeywordId = index;
				this.showIgnoreLoader = true;
				this.itemSelectedId = item.id;
				let vm  = this;
				this.$store.dispatch('campaign/addRecommendedKeyword', payload).then((res) => {
					vm.showIgnoreLoader = false;
					vm.ignoredKeywordId = -1;
					let addedIndex = vm.recommendationList.findIndex((res) =>  res.id == vm.itemSelectedId)
					vm.recommendationList.splice(addedIndex, 1)
					vm.itemSelectedId = -1;
				})
			}
		}
	};
</script>

}
